import LogsList from "./pages/LogsList.vue";
import LogDetailsViewPage from "./pages/LogDetailsViewPage.vue";

export default {
    LogsList,
    LogDetailsViewPage,
};
